import { Link } from "react-router-dom";
import Seo from "../components/Seo";

const LINKS = [
  ["Home", "/"],
  ["Stay", "/stay"],
  ["Experiences", "/experiences"],
  ["Wildlife", "/wildlife"],
  ["Journal", "/journal"],
  ["Plan Your Stay", "/plan"],
];

export default function NotFoundPage({ testid = "not-found-page" }) {
  return (
    <main data-testid={testid} className="mx-auto min-h-[70vh] max-w-4xl px-6 pb-24 pt-40 text-center sm:px-12 sm:pt-48">
      <Seo
        title="404 | The Jamoon"
        description="The requested page could not be found on The Jamoon website."
        path="/404"
        noindex
      />
      <p className="text-xs font-medium tracking-[0.35em] text-brass">404</p>
      <h1 className="mt-6 font-serif text-4xl font-light text-ivory sm:text-5xl">THE TRAIL ENDS HERE.</h1>
      <p className="mt-6 text-base font-light text-ivory/65">We couldn't find the page you're looking for.</p>
      <nav aria-label="Not found page links" className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-4">
        {LINKS.map(([label, to]) => (
          <Link
            key={to}
            data-testid={`not-found-${label.toLowerCase().replace(/\s+/g, "-")}-link`}
            to={to}
            className="text-xs tracking-[0.2em] text-brass transition-colors duration-300 hover:text-ivory"
          >
            {label.toUpperCase()}
          </Link>
        ))}
      </nav>
    </main>
  );
}